export const getBatchTeam = (batch = []) => {
  const leader = batch?.users?.filter(el => el.id === batch?.leader);
  return leader?.concat(batch?.users?.filter(el => el.id !== batch?.leader));
};
